import { useState } from "react";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import styled from "@emotion/styled";
import { REWARD_OFFERING } from "../constants";
import CompetitionPage from "../common/components/CompetitionPage";

const TicketSelectorContainer = styled(Box)`
  margin-bottom: 24px;
  width: 100%;
`;

const StyledFormControl = styled(FormControl)`
  width: 100%;
  
  .MuiInputLabel-root {
    color: #616161;
    &.Mui-focused {
      color: #0e893c;
    }
  }
  
  .MuiInput-root {
    &:before {
      border-bottom: 1px solid #e0e0e0;
    }
    &:hover:not(.Mui-disabled):before {
      border-bottom: 2px solid #0e893c;
    }
    &.Mui-focused:after {
      border-bottom: 2px solid #0e893c;
    }
  }

  .MuiSelect-icon {
    color: #616161;
  }
`;

function BridgeToBrisbaneMain() {
  const offerId = REWARD_OFFERING.bridgetobrisbanetactical;
  const [ticketCount, setTicketCount] = useState(1);

  const handleTicketChange = (event: any) => {
    setTicketCount(event.target.value);
  };

  return (
    <CompetitionPage 
      offerId={offerId}
      additionalData={{ ticketCount }}
      loadingMessage="Storing registration..."
      customContent={(hasEntered: boolean) =>
        !hasEntered ? (
          <TicketSelectorContainer>
            <StyledFormControl fullWidth variant="standard">
              <InputLabel>Number of Passes</InputLabel>
              <Select
                value={ticketCount}
                label="Number of Passes"
                onChange={handleTicketChange}
              >
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={2}>2</MenuItem>
                <MenuItem value={3}>3</MenuItem>
                <MenuItem value={4}>4</MenuItem>
              </Select>
            </StyledFormControl>
          </TicketSelectorContainer>
        ) : null
      }
    />
  );
}

export default BridgeToBrisbaneMain;